import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import { ETopUpSortField, ITopUp, PTopUpFilter } from "src/core/topUp/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface ITopUpState {
  topUps: ITopUp[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: ITopUpState = {
  topUps: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "top-up/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "top-up/FETCH_SUCCEEDED";
const FETCH_FAILED = "top-up/FETCH_FAILED";
const POLLING_START_REQUESTED = "top-up/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "top-up/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: ITopUp[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PTopUpFilter;
    pagination: IPagination;
    sorts: ISort<ETopUpSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<ITopUpState, TActions> = (
  state = initialState,
  action
) => {
  return produce<ITopUpState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.topUps = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
